import { KTIcon } from '@/_metronic/helpers';
import { type AnnouncementType } from '@/app/enums/AnnouncementType';
import AnnouncementAcknowledgement from '@/app/modules/announcements/components/AnnouncementAcknowledgement';
import { isMandatory } from '@/app/modules/announcements/core/_utils';

type AnnouncementPreviewActionsProps = {
  type: AnnouncementType;
  onClose: () => void;
};

/** As ações que o destinatário vê; para quem criou, a ciência fica inerte e o "Entendi" só fecha. */
const AnnouncementPreviewActions = ({ type, onClose }: AnnouncementPreviewActionsProps) => {
  if (isMandatory(type)) {
    return <AnnouncementAcknowledgement preview acknowledging={false} onAcknowledge={onClose} />;
  }

  return (
    <button
      className="btn announcement-modal-confirm announcement-modal-action w-100 d-flex align-items-center justify-content-center gap-2"
      type="button"
      onClick={onClose}
    >
      <KTIcon className="fs-2" iconName="check" />
      Entendi
    </button>
  );
};

export default AnnouncementPreviewActions;
